<template>
  <div class="filter-overlay">
    <div class="filter-content-container">
      <button v-if="hasNewFilters" class="apply-filter-btn bcLiguria" @click="$emit('apply-filters', filter)">{{ $t('projects.filters.applyFilters') }}</button>
      <CloseMenu class="close-icon" @click="$emit('close-filter')" />

      <ul class="filter-options-container filter-options-container-families">
        <li class="filter-option" :class="{'filter-option-selected': isFilterSelected(0, 'families')}" @mouseover="hoverColor = '#FFF'"
        @mouseleave="hoverColor = ''" @click="toggleItemFilter(0, 'families')">
          <div class="option-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
              <g id="Capa_2" data-name="Capa 2">
                <g id="Capa_1-2" data-name="Capa 1">
                  <path d="M0,0V40H40V0ZM24,24H16V16h8Z"/>
                </g>
              </g>
            </svg>
          </div>
          <span class="option-text bcLiguria">Todos los productos</span>
        </li>
        <li class="filter-option"
          :style="{
            backgroundColor: isFilterSelected(family.id, 'families') ? family.color : '',
          }"
          @mouseover="hoverColor = family.color"
          @mouseleave="hoverColor = ''"
          v-for="(family, index) in families"
          :key="index"
          @click="toggleItemFilter(family.id, 'families')">

          <div class="option-icon">
            <img :src="family.icon" alt="">
          </div>
          <span class="option-text bcLiguria">{{ family.name_lang[$i18n.locale] }}</span>
        </li>
      </ul>

      <ul class="filter-options-container filter-options-container-materials">
        <li class="filter-option" :class="{'filter-option-selected': isFilterSelected(0, 'materials')}" @click="toggleItemFilter(0, 'materials')">
          <div class="option-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
              <g id="Capa_2" data-name="Capa 2">
                <g id="Capa_1-2" data-name="Capa 1">
                  <path d="M0,0V40H40V0ZM24,24H16V16h8Z"/>
                </g>
              </g>
            </svg>
          </div>
          <span class="option-text bcLiguria">Todos los materiales</span>
        </li>
        <li class="filter-option" :class="{'filter-option-selected': isFilterSelected(material.id, 'materials')}" v-for="(material, index) in materials" :key="index" @click="toggleItemFilter(material.id, 'materials')">
          <div class="option-icon">
            <img :src="material.foto_file" alt="">
          </div>
          <span class="option-text bcLiguria">{{ material.nombre_lang[$i18n.locale] }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import CloseMenu from '@/assets/img/close-icon.svg'
import { gsap } from 'gsap'
export default {
  components: {
    CloseMenu
  },
  props: {
    filters: {
      type: Object,
      required: true
    },
    families: {
      type: Array,
      required: true
    },
    materials: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      filter: {
        families: [],
        materials: []
      },
      hoverColor: '',
      userAppliesFilters: false
    }
  },
  computed: {
    computedFilters: {
      get () {
        return JSON.parse(JSON.stringify(this.filters))
      },
      set (value) {
        // Emitir evento para que el padre reciba el cambio
        this.$emit('update:filters', value)
      }
    },
    hasNewFilters () {
      if (!this.userAppliesFilters) return false // Si el usuario no ha interactuado, no mostrar el botón
      return Object.keys(this.filter).some(key =>
        JSON.stringify(this.filter[key]) !== JSON.stringify(this.filters[key])
      )
    }
  },
  methods: {
    isFilterSelected (id, type) {
      return this.filter[type].includes(id)
    },
    toggleItemFilter (id, type) {
      // if (this.filter[type].includes(id)) {
      //   this.filter[type] = this.filter[type].filter(f => f !== id)
      // } else {
      //   this.filter[type].push(id)
      // }
      this.userAppliesFilters = true
      if (id === 0) {
        // Si se selecciona "Todos", se resetea el array y se deja solo el 0
        this.filter[type] = [0]
      } else {
        // Si se selecciona otro, quitamos "Todos" (0) si está presente
        this.filter[type] = this.filter[type].filter(f => f !== 0)

        if (this.filter[type].includes(id)) {
          // Si ya estaba seleccionado, lo removemos
          this.filter[type] = this.filter[type].filter(f => f !== id)
        } else {
          // Si no estaba seleccionado, lo agregamos
          this.filter[type].push(id)
        }
      }
    },
    initAnimation () {
      const tl = gsap.timeline()
      tl.from('.filter-overlay', {
        duration: 0.5,
        opacity: 0,
        ease: 'power2.out'
      })
      tl.to('.filter-content-container', {
        duration: 0.5,
        x: 0,
        ease: 'power2.out'
      }, '-=0.5')
      tl.to('.filter-option', {
        duration: 0.5,
        y: 0,
        opacity: 1,
        ease: 'power2.out',
        stagger: 0.1
      }, '-=0.5')
    }
  },
  mounted () {
    this.filter = JSON.parse(JSON.stringify(this.filters))

    if (!this.filter.families.length) {
      this.filter.families = [0]
    }
    if (!this.filter.materials.length) {
      this.filter.materials = [0]
    }

    // Actualizar `this.filters` para que no haya diferencia con `this.filter`
    this.computedFilters = JSON.parse(JSON.stringify(this.filter))

    this.initAnimation()
  }
}
</script>

<style lang="scss" scoped>
.filter-overlay {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;

  .filter-content-container {
    width: 50%;
    height: 100%;
    background-color: #1A1A1A;
    transform: translateX(100%);
    position: relative;
    overflow-y: auto;

    .apply-filter-btn {
      border: none;
      outline: none;
      position: absolute;
      top: 40px;
      left: 20px;
      height: 40px;
      color: #1A1A1A;
      padding: 0 var(--main-space);
      background-color: $footer-text;
      transition: all 0.3s ease-in-out;
      cursor: pointer;
      &:hover {
        background-color: #FFF;
      }
    }

    .close-icon {
      position: absolute;
      top: 40px;
      right: var(--main-space);
      width: 40px;
      fill: #FFF;
      cursor: pointer;
    }

    .filter-options-container {
      margin-top: 40px;
      margin-bottom: 0;
      display: flex;
      flex-direction: column;
      gap: 2px 0;

      &.filter-options-container-families {
        margin-top: 120px;

        .filter-option:hover {
          background-color: v-bind(hoverColor);
        }
        img{
          filter: grayscale(100%) brightness(0);
        }
      }

      .filter-option {
        height: 40px;
        background-color: $footer-text;
        padding: 0 20px;
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
        cursor: pointer;
        transform: translateY(100%);
        opacity: 0;

        &.filter-option-selected {
          background-color: #FFF;
        }

        &:hover {
          background-color: #FFF;
        }

        .option-icon {
          width: 40px;
          height: 40px;
          margin-right: calc(var(--main-space) / 2);

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center;
          }
        }
      }
    }
  }
}
@include media-breakpoint-down(sm) {
  .filter-overlay{
    z-index: 9999;
    .filter-content-container {
      width: 100%;
    }
  }
}
</style>
